@import url("../bam-promotion-list/bam-promotion-list.css");

.dark-mode .side-rail {
    border: 1px solid var(--color-dark-background);
    background-color: var(--color-dark-foreground);
    color: var(--color-dark-primary);
}

.dark-mode .dropdown, .dark-mode .dropdown-container {
    background-color:  var(--color-dark-foreground);
}

.dark-mode .dropdown-font {
    color: var(--color-dark-primary);
}

.dark-mode .dropdown-default-font {
    color: var(--color-dark-secondary);
}

.dark-mode .item__book-name, .dark-mode .featured-item__book-name {
    color: var(--color-dark-secondary);
}

.dark-mode .item__cta, .dark-mode .featured-item__cta {
    color: var(--color-dark-primary);
}

.dark-mode .text-dark {
    color: var(--color-dark-primary);
}
